import { ChangeEvent, FC, useState } from 'react';

import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';

import Queue from '@/shared/types/fulfilment/queue.type';

type FulfilCustomColumnProps = {
  queue: Queue;
  onBlur: (value: string, reason?: 'update-table') => void;
};

const FulfilCustomColumn: FC<FulfilCustomColumnProps> = ({ queue, onBlur }) => {
  const [fulfilQty, setFulfilQty] = useState(queue.fulfil_qty);
  const [validationError, setValidationError] = useState({
    fulfilQty: '',
  });

  const validate = () => {
    const errors: Record<keyof typeof validationError, string> = {
      fulfilQty: '',
    };

    if (
      parseInt(fulfilQty) >
      parseInt(queue.product_qty) - parseInt(queue.filled_qty)
    ) {
      errors.fulfilQty =
        'You cannot provide fulfil qty higher than product qty - fulfilled qty';
    } else if (parseInt(fulfilQty) < 0) {
      errors.fulfilQty =
        'You cannot provide negative values for fulfil quantity field';
    }

    setValidationError(errors);
    return Object.values(errors).some((error) => error !== '');
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setFulfilQty(value);
  };

  return (
    <TextField
      label=''
      error={validationError.fulfilQty !== ''}
      variant='standard'
      disabled={
        queue.status === 'CANCELED' ||
        queue.status === 'PAUSED' ||
        queue.status === 'SUBMITTED'
      }
      value={fulfilQty}
      inputProps={{ type: 'number' }}
      InputProps={{
        endAdornment:
          validationError.fulfilQty !== '' ? (
            <Tooltip
              title={validationError.fulfilQty}
              placement='top'
              arrow
              PopperProps={{
                sx: { maxWidth: 200 },
              }}
            >
              <ErrorOutlineIcon sx={{ width: 16, height: 16 }} color='error' />
            </Tooltip>
          ) : null,
      }}
      onChange={handleChange}
      onBlur={() => {
        const hasErrors = validate();

        if (!hasErrors && parseInt(fulfilQty) !== parseInt(queue.fulfil_qty)) {
          onBlur(
            fulfilQty,
            queue.status === 'HELD' ? 'update-table' : undefined,
          );
        }
      }}
      onKeyDown={(e) => e.stopPropagation()}
    />
  );
};

export default FulfilCustomColumn;
